/* global window:true */
/* global $:true */

import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import ReactGA from 'react-ga';

class Contact extends Component {
    componentDidMount() {
        const { actions } = this.props;

        // set breadcrumb
        actions.setBreadcrumb([{ title: 'Stats' }]);

        // log analytics
        ReactGA.pageview(window.location.pathname);

        actions.getStatsRequest();

        this.updateCounter();
    }

    componentDidUpdate() {
        this.updateCounter();
    }

    updateCounter() {
        const { stats } = this.props;

        $('.childrenReach').FlipClock(stats.childrenReached, {
            clockFace: 'Counter',
            minimumDigits: 7
        });
    }

    render() {
        const { stats } = this.props;
        // console.log('stats', stats);

        const isMobile = window.innerWidth < 560;

        return (
            <div className="portfolio-wrapper index-1">
                <Helmet title="Stats" />
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 stats-item primary">
                            <div className="caption">
                                <h2>Children reached</h2>
                                {isMobile ?
                                    <div className="mobile-counter">
                                        {stats.childrenReached}
                                    </div>
                                    :
                                    <div className="counter childrenReach" />
                                }
                            </div>
                        </div>
                        <div className="col-md-4 stats-item">
                            <div className="caption">
                                <h3>Time since launch</h3>
                                <p><span>{stats.weeksSinceLaunch}</span><br />weeks</p>
                            </div>
                        </div>
                        <div className="col-md-4 stats-item">
                            <div className="caption">
                                <h3>Number of UK primary schools using the portal</h3>
                                <p style={{ paddingTop: '50px' }}><span>{stats.schoolsCount}</span></p>
                            </div>
                        </div>
                        <div className="col-md-4 stats-item">
                            <div className="caption">
                                <h3>Percentage of the total UK schools</h3>
                                <p style={{ paddingTop: '50px' }}>
                                    <span style={{ fontSize: '30px' }}>{parseFloat(stats.schoolsPercentageTotal).toFixed(2)}%</span>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4 stats-item">
                            <div className="caption">
                                <h3>Logins this month</h3>
                                <p style={{ paddingTop: '50px' }}><span>{stats.loginCountThisMonth}</span></p>
                            </div>
                        </div>
                        <div className="col-md-4 stats-item">
                            <div className="caption">
                                <h3>Enterprise sessions booked</h3>
                                <p style={{ paddingTop: '50px' }}><span>{stats.bookingsCount}</span></p>
                            </div>
                        </div>
                        <div className="col-md-4 stats-item">
                            <div className="caption">
                                <h3>Number of parents using the portal</h3>
                                <p style={{ paddingTop: '50px' }}><span>{stats.usersCount}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Contact.propTypes = {
    actions: PropTypes.object,
    stats: PropTypes.object
};

export default Contact;



/** WEBPACK FOOTER **
 ** ./src/pages/ChartsPage.js
 **/